import React from "react";

import BrandMark from "../atoms/BrandMark";
import { getYearsInBusiness } from "../../data/brand";

export default function BrandPanel() {
  return (
    <aside className="flex flex-col justify-between gap-8 bg-blue-50 p-8 dark:bg-slate-700 sm:w-72 sm:shrink-0">
      <a href="/" aria-label="Digar home" className="inline-flex">
        <BrandMark />
      </a>

      <div>
        <h2 className="mb-2 text-2xl font-medium leading-tight text-blue-900 dark:text-gray-100">
          Operations, simplified.
        </h2>
        <p className="text-sm leading-relaxed text-blue-800/80 dark:text-gray-400">
          The platform Digar teams have trusted for {getYearsInBusiness()} years
          and counting.
        </p>
      </div>

      <p className="hidden text-xs text-blue-800/60 dark:text-gray-500 sm:block">
        © {new Date().getFullYear()} Digar LLC.
      </p>
    </aside>
  );
}
